import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

// eslint-disable-next-line max-len
const ENDPOINT = `${APIConfiguration.carrier}carriers/files/${COMMON_QUERY_PARAMS.FILE_ID}/urls/${COMMON_QUERY_PARAMS.MODULE_DEFINITION_ID}/${COMMON_QUERY_PARAMS.MODULE_INSTANCE_ID}`;

export interface GetShippingLabelUrlQueryArgs {
  fileId: string;
  moduleDefinitionId: string;
  moduleInstanceId: string;
}

export const getShippingLabelUrlRequest = (
  payload: GetShippingLabelUrlQueryArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, payload.fileId)
    .replace(COMMON_QUERY_PARAMS.MODULE_DEFINITION_ID, payload.moduleDefinitionId)
    .replace(COMMON_QUERY_PARAMS.MODULE_INSTANCE_ID, payload.moduleInstanceId),
  config: { method: SUPPORTED_METHODS.GET },
});

const getShippingLabelUrlQuery = async (
  payload: GetShippingLabelUrlQueryArgs,
): Promise<BackResponse<string> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<string>>(
      getShippingLabelUrlRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getShippingLabelUrlQuery;
